<template>
    
</template>
<script>

export default {
  props: {
      item: {
        type: Object,
        default: () => {}
      }
    },
   data: () => ({
       overlay: false,
       edit: false,
       alterred: false
  }),
  computed: {
    
  },
  methods: {
   
  }
}

</script>
